import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

/// Keeps an already-logged-in admin off the login screen. Renders the
/// login page (via Outlet) when there's no token; once a token exists,
/// redirects forward into the dashboard instead of rendering anything at
/// "/" itself.
export default function RequireBack() {
  const { token } = useSelector((state) => state.auth);
  return token ? <Navigate to="/targets" replace /> : <Outlet />;
}
